import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const Pages = {
  list: () => api.get("/pages").then((r) => r.data),
  get: (key) => api.get(`/pages/${key}`).then((r) => r.data),
  update: (key, payload) => api.put(`/pages/${key}`, payload).then((r) => r.data),
};

export const Packages = {
  list: (onlyActive = false) =>
    api.get("/packages", { params: { only_active: onlyActive } }).then((r) => r.data),
  get: (slug) => api.get(`/packages/${slug}`).then((r) => r.data),
  create: (payload) => api.post("/packages", payload).then((r) => r.data),
  update: (id, payload) => api.put(`/packages/${id}`, payload).then((r) => r.data),
  remove: (id) => api.delete(`/packages/${id}`).then((r) => r.data),
};

export const Leads = {
  create: (payload) => api.post("/leads", payload).then((r) => r.data),
  list: () => api.get("/leads").then((r) => r.data),
  updateStatus: (id, status) =>
    api.put(`/leads/${id}`, { status }).then((r) => r.data),
  remove: (id) => api.delete(`/leads/${id}`).then((r) => r.data),
};

export const Admins = {
  list: () => api.get("/admins").then((r) => r.data),
  add: (email) => api.post("/admins", { email }).then((r) => r.data),
  remove: (email) =>
    api.delete(`/admins/${encodeURIComponent(email)}`).then((r) => r.data),
};

export const Testimonials = {
  list: (onlyActive = false) =>
    api.get("/testimonials", { params: { only_active: onlyActive } }).then((r) => r.data),
  create: (payload) => api.post("/testimonials", payload).then((r) => r.data),
  update: (id, payload) => api.put(`/testimonials/${id}`, payload).then((r) => r.data),
  remove: (id) => api.delete(`/testimonials/${id}`).then((r) => r.data),
};

export const BeforeAfter = {
  list: (onlyActive = false) =>
    api.get("/before-after", { params: { only_active: onlyActive } }).then((r) => r.data),
  create: (payload) => api.post("/before-after", payload).then((r) => r.data),
  update: (id, payload) => api.put(`/before-after/${id}`, payload).then((r) => r.data),
  remove: (id) => api.delete(`/before-after/${id}`).then((r) => r.data),
};

export const SitePages = {
  list: (onlyPublished = true) =>
    api.get("/site-pages", { params: { only_published: onlyPublished } }).then((r) => r.data),
  getPublic: (slug) => api.get(`/site-pages/${slug}`).then((r) => r.data),
  getAdmin: (id) => api.get(`/admin/site-pages/${id}`).then((r) => r.data),
  create: (payload) => api.post("/site-pages", payload).then((r) => r.data),
  update: (id, payload) => api.put(`/site-pages/${id}`, payload).then((r) => r.data),
  remove: (id) => api.delete(`/site-pages/${id}`).then((r) => r.data),
  importStarters: () => api.post("/site-pages/import-starters").then((r) => r.data),
};

export const NavSettings = {
  get: () => api.get("/nav-settings").then((r) => r.data),
  update: (payload) => api.put("/nav-settings", payload).then((r) => r.data),
};

export const Auth = {
  me: () => api.get("/auth/me").then((r) => r.data),
  session: (session_id) =>
    api.post("/auth/session", { session_id }).then((r) => r.data),
  logout: () => api.post("/auth/logout").then((r) => r.data),
};

export const ImageTools = {
  erase: (payload) => api.post("/image-tools/erase", payload).then((r) => r.data),
};

export const Portal = {
  accessCheck: () => api.get("/portal/access-check").then((r) => r.data),
  // Invites (admin)
  invites: {
    list: () => api.get("/portal/invites").then((r) => r.data),
    create: (payload) => api.post("/portal/invites", payload).then((r) => r.data),
    update: (id, payload) => api.put(`/portal/invites/${id}`, payload).then((r) => r.data),
    remove: (id) => api.delete(`/portal/invites/${id}`).then((r) => r.data),
  },
  // Training videos
  videos: {
    list: () => api.get("/portal/videos").then((r) => r.data),
    create: (payload) => api.post("/portal/videos", payload).then((r) => r.data),
    update: (id, payload) => api.put(`/portal/videos/${id}`, payload).then((r) => r.data),
    remove: (id) => api.delete(`/portal/videos/${id}`).then((r) => r.data),
  },
  // Manuals / PDFs
  docs: {
    list: () => api.get("/portal/docs").then((r) => r.data),
    create: (payload) => api.post("/portal/docs", payload).then((r) => r.data),
    update: (id, payload) => api.put(`/portal/docs/${id}`, payload).then((r) => r.data),
    remove: (id) => api.delete(`/portal/docs/${id}`).then((r) => r.data),
  },
  // Reorder requests
  orders: {
    create: (payload) => api.post("/portal/orders", payload).then((r) => r.data),
    mine: () => api.get("/portal/orders/mine").then((r) => r.data),
    listAll: () => api.get("/portal/orders").then((r) => r.data),
    updateStatus: (id, status) => api.put(`/portal/orders/${id}`, { status }).then((r) => r.data),
  },
  // Product pricing catalog
  products: {
    list: () => api.get("/portal/products").then((r) => r.data),
    create: (payload) => api.post("/portal/products", payload).then((r) => r.data),
    update: (id, payload) => api.put(`/portal/products/${id}`, payload).then((r) => r.data),
    remove: (id) => api.delete(`/portal/products/${id}`).then((r) => r.data),
  },
  // Q&A: articles + questions
  articles: {
    list: () => api.get("/portal/articles").then((r) => r.data),
    create: (payload) => api.post("/portal/articles", payload).then((r) => r.data),
    update: (id, payload) => api.put(`/portal/articles/${id}`, payload).then((r) => r.data),
    remove: (id) => api.delete(`/portal/articles/${id}`).then((r) => r.data),
  },
  questions: {
    submit: (payload) => api.post("/portal/questions", payload).then((r) => r.data),
    mine: () => api.get("/portal/questions/mine").then((r) => r.data),
    listAll: () => api.get("/portal/questions").then((r) => r.data),
    reply: (id, payload) => api.put(`/portal/questions/${id}`, payload).then((r) => r.data),
  },
  // Messages
  messages: {
    send: (payload) => api.post("/portal/messages", payload).then((r) => r.data),
    listAll: () => api.get("/portal/messages").then((r) => r.data),
    markRead: (id) => api.put(`/portal/messages/${id}`).then((r) => r.data),
  },
};
